import React from 'react';
import EspecialistaForm from './EspecialistaForm';

const EspecialistaCreate = () => {
  return <EspecialistaForm />;
};

export default EspecialistaCreate;